export default {
      id: "logo_givrand-usage",
      viewBox: "0 0 165 230",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#logo_givrand-usage",
      toString: function () {
        return this.url;
      }
    }